import { excludedLanguageFromUrl, languages } from '@valk-nx/core/lib/core';

export class DocumentLangHelper {
	static setFromUrl(windowLocation: string | undefined): void {
		if (!windowLocation) {
			return;
		}
		document.documentElement.lang =
			DocumentLangHelper.getLanguageFromUrl(windowLocation);
	}

	static getLanguageFromUrl(windowLocation: string): string {
		const seg = windowLocation.split('/')[1];
		return (languages as readonly string[]).includes(seg)
			? seg
			: excludedLanguageFromUrl;
	}
}
